import React from 'react';
import AvisoSoloLectura from './AvisoSoloLectura';
import { rolDeSesion, esAdministrador, veCobroConPinpad, MENSAJE_SOLO_LECTURA } from '../utilities/permisos';
import { nombreConSolicitante } from '../hooks/useCobroExternos';

const VistaCobroExternos = (props) => {
  const {
    externos, externoSeleccionado, setExternoSeleccionado, loadingLista, montoManual, setMontoManual,
    nombreSolicitante, setNombreSolicitante,
    handleAgregarAlCarrito, mensaje, carrito, procesarCobroPinpad, procesarCobroVentanilla, loading,
    setVistaActual, modalExito, setModalExito
  } = props;

  const rolCajero = rolDeSesion();
  // El Administrador (rol 1) consulta; los botones de cobro quedan deshabilitados
  const soloLectura = esAdministrador(rolCajero);

  return (
    <div className="cobro-layout">
      {/* Columna Izquierda: Formulario */}
      <div className="catalogo-section">
        <div className="catalogo-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div><h3>☕ Configuración de Cobro a Externos</h3><p>Selecciona la concesión e ingresa el monto.</p></div>
          {externoSeleccionado && (
            <div className="fila-botones">
              <button className="btn-select historial" onClick={() => setVistaActual('historial')} style={{ padding: '8px 15px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>📜 Historial de Pagos</button>
            </div>
          )}
        </div>

        <div className="cobro-form-container">
          <div>
            <label className="filter-label">Concesionario / Externo</label>
            {loadingLista ? ( <div style={{ color: '#666', padding: '10px' }}>⏳ Cargando lista...</div> ) : (
              <select className="search-input" value={externoSeleccionado} onChange={(e) => setExternoSeleccionado(e.target.value)}>
                <option value="">-- Selecciona una opción --</option>
                {externos.map((ex) => ( <option key={ex.matricula} value={ex.matricula}>{ex.nombre}</option> ))}
              </select>
            )}
          </div>
          <div>
            <label className="filter-label">Nombre de la persona (opcional)</label>
            <input type="text" maxLength={100} placeholder="Ej. nombre completo de quien paga" className="search-input" value={nombreSolicitante} onChange={(e) => setNombreSolicitante(e.target.value)} disabled={!externoSeleccionado} />
          </div>
          <div>
            <label className="filter-label">Importe a Cobrar Nuevo ($)</label>
            <input type="number" step="0.01" placeholder="0.00" className="search-input input-monto" value={montoManual} onChange={(e) => setMontoManual(e.target.value)} disabled={!externoSeleccionado} />
          </div>
          <button className="btn-preparar" onClick={handleAgregarAlCarrito} disabled={!externoSeleccionado || loadingLista}>🛒 Preparar Cobro</button>
          {mensaje.texto && ( <div className={`alert-box ${mensaje.tipo === 'success' ? 'alert-success' : 'alert-error'}`}><span className="alert-icon">{mensaje.tipo === 'success' ? '✅' : '⚠️'}</span>{mensaje.texto}</div> )}
        </div>
      </div>

      {/* Columna Derecha: Ticket */}
      <div className="ticket-section">
        <div className="ticket-card">
          <h3 className="ticket-title">Resumen del Pago</h3>
          {carrito ? (
            <>
              <div className="ticket-items-container">
                <div className="ticket-beneficiario"><p className="beneficiario-label">Beneficiario</p><p className="beneficiario-nombre">{nombreConSolicitante(carrito.nombre, carrito.solicitante)}</p></div>
                <div className="ticket-item"><span className="item-nombre">{carrito.descripcion}</span></div>
              </div>
              <div className="ticket-footer">
                <div className="ticket-total"><span>TOTAL:</span><span className="total-monto">${carrito.precio.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span></div>
                <div className="btn-action-container">
                  <AvisoSoloLectura visible={soloLectura} />
                  {veCobroConPinpad(rolCajero) && (
                    <button className="btn-pagar-grande" onClick={procesarCobroPinpad} disabled={soloLectura || loading} title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}>{loading ? 'Procesando...' : '💳 Cobrar con Pinpad'}</button>
                  )}
                  <button className="btn-pagar-grande btn-pagar-verde" onClick={procesarCobroVentanilla} disabled={loading}>{loading ? 'Procesando...' : '🏦 Generar Referencia'}</button>
                </div>
              </div>
            </>
          ) : ( <div className="ticket-vacio"><span className="vacio-icono">🛒</span>No hay conceptos en preparación</div> )}
        </div>
      </div>

      {modalExito.visible && (
        <div className="modal-overlay-exito">
          <div className="modal-card-exito">
            <div className="modal-icon-exito">🎉</div><h2 className="modal-title-exito">¡Cobro Registrado con Éxito!</h2>
            <div className="modal-detalles-exito">
              <div className="detalle-row-exito"><span>Concesionario:</span><strong>{modalExito.nombre}</strong></div>
              <div className="detalle-row-exito"><span>Monto:</span><strong className="monto-resaltado-exito">${modalExito.monto.toLocaleString('en-US', { minimumFractionDigits: 2 })} MXN</strong></div>
              <div className="detalle-row-exito"><span>No. Autorización:</span><strong className="codigo-exito">{modalExito.autorizacion}</strong></div>
              <div className="detalle-row-exito"><span>Referencia:</span><strong className="codigo-exito">{modalExito.referencia}</strong></div>
            </div>
            <button className="btn-modal-aceptar-exito" onClick={() => setModalExito({ ...modalExito, visible: false })}>Aceptar y Continuar</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default VistaCobroExternos;